const TreeStateActions = {
    updateTree: "updateTree"
};

const TreeState = {
    state: {
        storeTree: []
    },
    mutations: {
        updateTreeStore(state, newTree) {
            state.storeTree = newTree
        }
    },
    actions: {
        updateTree(context, tree) {
            context.commit('updateTreeStore', tree)
        }
    },
    getters: {
        tree(state) {
            return state.storeTree
        }
    }
}

export {
    TreeState,
    TreeStateActions
};